// extracted by mini-css-extract-plugin
export default {"serviceItemsPage":"styles_serviceItemsPage__1L2h6","serviceItems":"styles_serviceItems__PfKVH","linkContainer":"styles_linkContainer__rw2Kn","linkP":"styles_linkP__jI4jU"};